import React from 'react';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';

export default function ResultEditButtons(props) {
  const { id, handleViewDeleteModal, openEditAlert } = props;

  return (
    <section className="result-edit-buttons els-btn-group">
      <ButtonWithIcon
        data-e2e="alert-edit-button"
        type="link"
        sprite="Edit"
        iconRight
        className={`alerts--second-line results-from--edit-button e2e-${id}-edit`}
        onClick={() => {
          openEditAlert(id);
        }}>
        Edit
      </ButtonWithIcon>

      <ButtonWithIcon
        data-e2e="alert-delete-button"
        id={`alert-delete-${id}`}
        type="link"
        sprite="Trash"
        iconRight
        className={`alerts--second-line e2e-${id}-delete`}
        onClick={() => {
          handleViewDeleteModal(true, id);
        }}>
        Delete
      </ButtonWithIcon>
    </section>
  );
}

ResultEditButtons.propTypes = {
  id: PropTypes.string.isRequired,
  handleViewDeleteModal: PropTypes.func.isRequired,
  openEditAlert: PropTypes.func.isRequired,
};
